/* Costa slide-out cart drawer - self-contained.
   - Intercepts real add-to-cart forms (form[action*="/cart/add"]).
   - One-step "quick add" for lineup/collection buttons (a[class*="btn-add-cart"]
     that link to /products/...): adds the first available variant, opens the drawer.
   - Header .costa-cart-btn opens the drawer. Live count, qty/remove, checkout.
   Endpoints: /cart.js, /cart/add.js, /cart/change.js, /products/<handle>.js.
   Progressive enhancement: if the script or an endpoint fails, quick-add links
   still navigate to the product page (their default href). */
(function () {
  'use strict';
  var drawer, overlay, itemsEl, footEl;

  function money(c){ return '$' + (Math.round(c) / 100).toFixed(2); }

  function build(){
    overlay = document.createElement('div');
    overlay.className = 'costa-cd-overlay';
    overlay.addEventListener('click', close);

    drawer = document.createElement('aside');
    drawer.className = 'costa-cd';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-label', 'Shopping cart');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="costa-cd-head"><span class="costa-cd-title">Your Cart</span>' +
      '<button class="costa-cd-close" type="button" aria-label="Close cart">×</button></div>' +
      '<div class="costa-cd-body"></div>' +
      '<div class="costa-cd-foot"></div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    itemsEl = drawer.querySelector('.costa-cd-body');
    footEl = drawer.querySelector('.costa-cd-foot');
    drawer.querySelector('.costa-cd-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e){ if (e.key === 'Escape') close(); });
  }

  function open(){
    drawer.classList.add('is-open'); overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('costa-cd-lock');
  }
  function close(){
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('costa-cd-lock');
  }

  function sizedImg(url){
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  function updateCount(n){
    var btns = document.querySelectorAll('.costa-cart-btn');
    for (var i = 0; i < btns.length; i++){ btns[i].textContent = 'Cart (' + n + ')'; }
  }

  function render(cart){
    updateCount(cart.item_count);
    if (!cart.items || !cart.items.length){
      itemsEl.innerHTML = '<div class="costa-cd-empty"><p>Your cart is empty.</p>' +
        '<a class="costa-cd-cont" href="/collections/all">Continue shopping</a></div>';
      footEl.innerHTML = '';
      return;
    }
    var html = '';
    cart.items.forEach(function (it){
      var opts = (it.options_with_values || [])
        .filter(function (o){ return o.value && o.value.toLowerCase() !== 'default title'; })
        .map(function (o){ return o.value; }).join(' / ');
      var img = sizedImg((it.featured_image && it.featured_image.url) || it.image);
      html +=
        '<div class="costa-cd-item" data-key="' + it.key + '">' +
        (img
          ? '<img class="costa-cd-thumb" src="' + img + '" alt="" width="60" height="60" loading="lazy">'
          : '<span class="costa-cd-thumb"></span>') +
        '<div class="costa-cd-info">' +
          '<a class="costa-cd-name" href="' + it.url + '">' + it.product_title + '</a>' +
          (opts ? '<div class="costa-cd-variant">' + opts + '</div>' : '') +
          '<div class="costa-cd-qty">' +
            '<button type="button" class="costa-cd-dec" aria-label="Decrease quantity">−</button>' +
            '<span class="costa-cd-q">' + it.quantity + '</span>' +
            '<button type="button" class="costa-cd-inc" aria-label="Increase quantity">+</button>' +
            '<button type="button" class="costa-cd-rm">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="costa-cd-price">' + money(it.final_line_price) + '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
    footEl.innerHTML =
      '<div class="costa-cd-sub"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<p class="costa-cd-note">Taxes and shipping calculated at checkout.</p>' +
      '<a class="costa-cd-checkout" href="/checkout">Check Out</a>' +
      '<a class="costa-cd-viewcart" href="/cart">View cart</a>';
  }

  function getCart(){ return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r){ return r.json(); }); }
  function refresh(openAfter){ return getCart().then(function (cart){ render(cart); if (openAfter) open(); }); }

  function change(key, qty){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r){ return r.json(); }).then(render);
  }

  function postAdd(fd){
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r){
      if (!r.ok) return r.json().then(function (e){ throw e; });
      return r.json();
    }).then(function (){ return refresh(true); })
    .catch(function (err){
      window.alert((err && (err.description || err.message)) || 'Sorry, this item could not be added to your cart.');
    });
  }

  function addForm(form){
    var btn = form.querySelector('button[type="submit"], button:not([type]), [type="submit"]');
    if (btn) btn.classList.add('is-loading');
    return postAdd(new FormData(form)).then(function (){ if (btn) btn.classList.remove('is-loading'); });
  }

  function addVariant(id){
    var fd = new FormData(); fd.append('id', id); fd.append('quantity', 1);
    return postAdd(fd);
  }

  function quickAdd(handle, btn){
    if (btn) btn.classList.add('is-loading');
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r){ if (!r.ok) throw new Error('fetch'); return r.json(); })
      .then(function (p){
        var vs = p.variants || [];
        var v = vs.filter(function (x){ return x.available; })[0] || vs[0];
        if (!v) throw new Error('novariant');
        return addVariant(v.id);
      })
      .catch(function (){ window.location.href = '/products/' + handle; })
      .then(function (){ if (btn) btn.classList.remove('is-loading'); });
  }

  function init(){
    build();

    document.addEventListener('submit', function (e){
      var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
      if (form){ e.preventDefault(); addForm(form); }
    });

    document.addEventListener('click', function (e){
      var t = e.target; if (!t.closest) return;

      // Header cart button -> open drawer
      if (t.closest('.costa-cart-btn')){ e.preventDefault(); refresh(true); return; }

      // One-step quick add: any lineup/collection "Add to Cart" link to a product
      var qa = t.closest('a[class*="btn-add-cart"]');
      if (qa){
        var href = qa.getAttribute('href') || '';
        var idx = href.indexOf('/products/');
        if (idx > -1){
          e.preventDefault();
          var handle = href.slice(idx + 10).split(/[?#]/)[0];
          quickAdd(handle, qa);
          return;
        }
      }

      // Drawer quantity / remove
      var item = t.closest('.costa-cd-item'); if (!item) return;
      var key = item.getAttribute('data-key');
      var q = parseInt(item.querySelector('.costa-cd-q').textContent, 10) || 1;
      if (t.closest('.costa-cd-inc')) change(key, q + 1);
      else if (t.closest('.costa-cd-dec')) change(key, q - 1 < 0 ? 0 : q - 1);
      else if (t.closest('.costa-cd-rm')) change(key, 0);
    });

    getCart().then(function (cart){ updateCount(cart.item_count); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
